<template>
    <div class="home">
        <loading :active.sync="!this.ships.length"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
        <side-bar
                :ships="filteredShips"
                :showDisembarked="showDisembarked"
                @zoomShip="$refs.map.zoomToShip($event)"
                @showDisembarked="showDisembarked = !showDisembarked"
        ></side-bar>
        <here-map
                ref="map"
                :ships="filteredShips"
                :appId="appId"
                :api-key="apiKey"
                lat="0"
                lng="0"
                width="100%"
                height="835px"/>
    </div>
</template>

<script>
  import HereMap from '../components/HereMap'
  import SideBar from '../components/SideBar'
  import Axios from 'axios'

  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    name: 'Home',
    components: {
      SideBar,
      HereMap,
      Loading,
    },
    methods: {
      loadShips () {
        Axios.get('https://covid-cruise-tracker.atymic.dev/.netlify/functions/data-api?v=2').then(res => {
          this.ships = res.data
        })
      },
    },
    created () {
      this.loadShips()
    },
    computed: {
      filteredShips () {
        let ships = this.ships

        if (!this.showDisembarked) {
          ships = ships.filter(ship => !ship.data.disembarked)
        }

        return ships
      },
    },
    data () {
      return {
        ships: [],
        showDisembarked: true,
        appId: process.env.VUE_APP_HERE_APP_ID,
        apiKey: process.env.VUE_APP_HERE_APP_KEY,
      }
    },
  }
</script>
